/**
 * Click-to-place preview for Quick Chat / Voice — mirrors ChatSessionNode's
 * rust bubble (constant 40×40 screen px, centered on the cursor).
 */

import { cn } from "@/utils";
import { useViewport, ViewportPortal } from "@xyflow/react";
import { MessageSquare, Mic } from "lucide-react";
import {
  type DeferredQuickComposeGhost,
  QUICK_COMPOSE_GHOST_ICON_SIZE,
} from "../hooks/useDeferredQuickChatPlacement";

export function DeferredQuickComposeGhostPreview({
  ghost,
}: {
  ghost: DeferredQuickComposeGhost;
}) {
  const { zoom } = useViewport();
  const inverseScale = 1 / zoom;
  const halfIconFlow = (QUICK_COMPOSE_GHOST_ICON_SIZE / 2) * inverseScale;
  const Icon = ghost.mode === "quick-voice" ? Mic : MessageSquare;

  return (
    <ViewportPortal>
      <div
        className="absolute pointer-events-none"
        style={{
          left: ghost.center.x - halfIconFlow,
          top: ghost.center.y - halfIconFlow,
          transform: `scale(${inverseScale})`,
          transformOrigin: "top left",
        }}
      >
        <div
          className={cn(
            "relative flex size-10 items-center justify-center rounded-full shadow-elev-4",
            "bg-rust/70 ring-2 ring-rust/50",
          )}
        >
          <Icon className="size-5 text-paper" strokeWidth={2} />
        </div>
      </div>
    </ViewportPortal>
  );
}
